import { SaleRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { CreateSaleType, ReturnEntry } from "@utilities/types";

export const salesService = {
    createSale: async (saleData: Partial<CreateSaleType>) => {
        return await fetchRequest({
            route: `${SaleRoutesEnum.SALE_CREATE}`,
            method: "POST",
            data: saleData,
        });
    },

    getAllSales: async (organisationID: string) => {
        return await fetchRequest({
            route: `${SaleRoutesEnum.SALE_GET_ALL}/${organisationID}`,
            method: "GET",
        });
    },
    
    returnProduct: async (saleID: string, returnEntry: ReturnEntry) => {
        return await fetchRequest({
            route: `${SaleRoutesEnum.SALE_RETURN_PRODUCT}/${saleID}`,
            method: 'PUT',
            data: returnEntry
        })
    }
};
